/**
 * TICTAC 2 GO — landing interactions (2026 design).
 *   • header drawer open/close
 *   • "why" carousel arrows
 *   • bundle colour swatches swapping the floating cutout
 * Written as plain ES5-ish DOM code so it needs no build step, and re-binds
 * on Shopify's section:load so the theme editor stays interactive.
 */
(function () {
  function initDrawer(root) {
    var drawer = root.querySelector('[data-tt-drawer]');
    if (!drawer) return;
    var openBtn = root.querySelector('[data-tt-drawer-open]');
    function setOpen(open) {
      drawer.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    }
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    root.querySelectorAll('[data-tt-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) setOpen(false);
    });
  }

  function initWhy(root) {
    var track = root.querySelector('[data-why-track]');
    if (!track) return;

    /* While the track moves, cards slide underneath a stationary cursor and
       each one flashes its hover lift in turn — which reads as the edges of
       the outgoing photo changing. Flag the scroll and let CSS mute hover
       until it settles. */
    var settle;
    track.addEventListener('scroll', function () {
      track.classList.add('is-scrolling');
      clearTimeout(settle);
      settle = setTimeout(function () { track.classList.remove('is-scrolling'); }, 160);
    }, { passive: true });

    function step(dir) {
      var card = track.querySelector('.lp-why-card');
      var amount = card ? card.getBoundingClientRect().width + 20 : 360;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-why-prev]');
    var next = root.querySelector('[data-why-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function initBundle(root) {
    var photo = root.querySelector('[data-bundle-photo]');
    if (!photo) return;
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-swatch]'));
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isActive = btn.classList.contains('is-active');
        swatches.forEach(function (b) { b.classList.remove('is-active'); });
        if (isActive) {
          photo.src = photo.getAttribute('data-default');   // toggle back to the styled shot
          return;
        }
        btn.classList.add('is-active');
        photo.src = btn.getAttribute('data-photo');
        photo.alt = btn.getAttribute('data-alt') || photo.alt;
      });
    });
  }

  function initAll(root) {
    initDrawer(root);
    initWhy(root);
    initBundle(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
